export default {
    1: 'RIDE_SHARING_SERVICE',
    2: 'DELIVERY_SERVICE',
    3: "CANNABIS_SERVICE",
    4: "BULK_SERVICE",
    5: "DELIVERY_SERVICE_AMBULANCE"
}